import React, { useState } from 'react';
import { Modal } from './Modal';

type Props = {
  open: boolean;
  onImport: (titles: string[]) => void;
  onClose: () => void;
};

export const ImportTextDialog: React.FC<Props> = ({ open, onImport, onClose }) => {
  const [text, setText] = useState('');

  const handleImport = () => {
    const titles = text
      .split('\n')
      .map(line => line.trim())
      .filter(line => line.length > 0);

    if (titles.length > 0) {
      onImport(titles);
    }
    setText('');
    onClose();
  };

  const handleClose = () => {
    setText('');
    onClose();
  };

  const lineCount = text.split('\n').filter(l => l.trim().length > 0).length;

  return (
    <Modal open={open} onClose={handleClose} title="Import tasks from text" width={480}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <div style={{ fontSize: 13, color: '#666', lineHeight: '1.5' }}>
          Paste task titles — one per line. Empty lines are ignored.
          Each task will start <strong>today</strong> with a <strong>3-day</strong> duration.
        </div>

        <textarea
          value={text}
          onChange={e => setText(e.target.value)}
          placeholder={'Task 1\nTask 2\nTask 3'}
          rows={10}
          autoFocus
          style={{
            width: '100%',
            boxSizing: 'border-box',
            padding: '8px',
            border: '1px solid #d0d0d0',
            borderRadius: 4,
            fontSize: 13,
            fontFamily: 'monospace',
            resize: 'vertical',
            outline: 'none',
          }}
        />

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: 12, color: '#aaa' }}>
            {lineCount} task{lineCount !== 1 ? 's' : ''}
          </span>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={handleClose} style={cancelBtnStyle}>Cancel</button>
            <button
              onClick={handleImport}
              disabled={lineCount === 0}
              style={{ ...importBtnStyle, opacity: lineCount === 0 ? 0.5 : 1 }}
            >
              Import {lineCount > 0 ? `(${lineCount})` : ''}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

const cancelBtnStyle: React.CSSProperties = {
  padding: '6px 14px',
  background: '#f5f5f5',
  color: '#333',
  border: '1px solid #d0d0d0',
  borderRadius: 4,
  cursor: 'pointer',
  fontSize: 13,
};

const importBtnStyle: React.CSSProperties = {
  padding: '6px 14px',
  background: '#3b82f6',
  color: '#fff',
  border: 'none',
  borderRadius: 4,
  cursor: 'pointer',
  fontSize: 13,
};
